<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-sm-auto col-md-4 col-lg-5">
        <p class="h3 mt-4 text-center">Login</p>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-auto col-md-4 col-lg-5 p-4">
        <b-form
          @submit="onSubmit"
          ref="albumData"
        >
          <b-form-group
            id="input-group-1"
            label="Email address:"
            label-for="input-1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              required
              placeholder="Enter email"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Password:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="form.password"
              required
              placeholder="Enter Password"
              type="password"
            ></b-form-input>
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            class="mr-4"
          >Login</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      form: {},
      authenticated: false
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      /* formData */
      var formData = new FormData()
      formData.append('email', this.form.email)
      formData.append('password', this.form.password)
      this.progressInd = true
      /* AJAX request */
      axios
        .post('login', formData)
        .then(response => {
          if (response.data.message === 'Success') {
            this.$bvToast.toast('Login Successful', {
              title: 'Success',
              variant: 'success',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          } else {
            this.$bvToast.toast('Invalid Credentials', {
              title: 'Failed',
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
        })
    }
  },
  mounted () {
    axios
      .get('login')
      .then(response => {
        if (response.data.message === 'Success') {
          this.$bvToast.toast('Logout Successful', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            solid: true
          })
        }
      })
  }
}
</script>

<style scoped>
.folder:hover,
.folder:focus,
.folder:active {
  background-color: #a08d02b8 !important; /*#007bff*/
}
.folder {
  background-color: #fdde054a !important; /*#007bff*/
}

.scale-on-hover:hover {
  transform: scale(1.05);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.15) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue